module.exports = __webpack_public_path__ + "static/media/ppt_placeholder.f1d0d6d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ppt_placeholder.jpg
// module id = 1993
// module chunks = 6